import api from "@/services/api";
import { BehaviorSubject } from "rxjs";

class PagesCache {
  pages$ = new BehaviorSubject([]);

  constructor() {
    this._loadPages().catch(console.error);
  }

  async _loadPages() {
    const response = await api.getPages();
    const pages = response.data;
    if (!pages || !pages.length) return;
    pages.forEach((page: any) => page.meta = JSON.parse(page.meta ?? '{}'));
    this.pages$.next(response.data);
  }
}

export default new PagesCache();
